export default __webpack_public_path__ + "static/char-s-21-zh-Hant-e20d82e67159a35bfbeab850a106b4ee.png";